var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-intro",style:(this.background)},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(" "+_vm._s(this.title)+" ")]),(this.subtitle)?_c('h2',{domProps:{"innerHTML":_vm._s(this.subtitle)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }